import { FC } from 'react';
import { DeletePaymentDisable } from './DeletePaymentDiableComponent/DeletePaymentDisable';

export const DeletePaymentDisablePage: FC = () => {
  return <DeletePaymentDisable />;
};
